import React, {Component} from "react";
import Tags from 'react-tag-autocomplete';

import classes from "./styles.module.css";

class StatisticTag extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tags: [],
            initSuggestions: [],
            suggestions: [],
            filterProjects: props.filterProjects
        }

        this.tagsList = props.tagsList;
        this.reactTags = React.createRef()
    }

    static getDerivedStateFromProps(nextProps) {

        return {
            initSuggestions: nextProps.tagsList,
            filterProjects: nextProps.filterProjects,
        }
    }

    handleDelete(i) {
        const tags = this.state.tags.slice(0)
        tags.splice(i, 1)
        this.setState({tags})
        this.props.onSelectedTag(tags);
    }

    handleAddition(tag) {
        this.setState({tags: [...this.state.tags, tag]});
        this.props.onSelectedTag([...this.state.tags, tag]);
    }

    onInput() {
        if (this.state.initSuggestions.length && this.state.filterProjects.length) {

            let result = [];

            this.state.filterProjects.map(project => {
                this.state.initSuggestions.forEach(tag => {
                    if (String(tag.merchantUUID) === String(project)) {
                        result.push(tag);
                    }
                })

                return true;
            })

            this.setState({suggestions: result});

        } else {
            this.setState({suggestions: this.state.initSuggestions})
        }
    }

    render() {
        return (
            <Tags
                ref={this.reactTags}
                tags={this.state.tags}
                suggestions={this.state.suggestions}
                handleDelete={this.handleDelete.bind(this)}
                handleAddition={this.handleAddition.bind(this)}
                handleInputChange={this.onInput.bind(this)}
                allowNew={false}
                autoresize={false}
                placeholder="Введите метки для фильра"
                noSuggestionsText="Меток не найлено"
                addOnBlur={true}
                minQueryLength={1}
                classNames={
                    {
                        root: classes.Wrap,
                        rootFocused: classes.isFocused,
                        selected: classes.Selected,
                        selectedTag: classes.SelectedTag,
                        selectedTagName: 'react-tags__selected-tag-name',
                        search: classes.Wrap,
                        searchInput: classes.Input,
                        suggestions: classes.Suggestions,
                        suggestionActive: 'is-active',
                        suggestionDisabled: 'is-disabled'
                    }
                }
            />
        )
    }
}

export default StatisticTag;


// WEBPACK FOOTER //
// ./src/Components/StatisticTag/index.js